module.exports = __webpack_public_path__ + "media/images/front/icons/mark_watching-ef1cfd41a98ec16a6bda7e0f8bfea958.svg";